import { PropsWithChildren } from 'react';
import { useIsomorphicLayoutEffect } from 'motion/react';

import { cn } from '@components/primitives/utilities';

import { useSwitchContext } from './context';

import styles from './styles.module.css';

export interface SwitchLabelProps extends PropsWithChildren {
  className?: string;
}

/**
 * Visible text beside the track, which becomes the control's accessible name.
 * It supersedes any `aria-label` on the `<Switch>`.
 */
export function SwitchLabel({ className, children }: SwitchLabelProps) {
  const { labelId, registerLabel } = useSwitchContext();

  // Layout effect so the name is wired up before the first paint.
  useIsomorphicLayoutEffect(() => registerLabel(), [registerLabel]);

  return (
    <span id={labelId} className={cn(styles.label, className)}>
      {children}
    </span>
  );
}
